import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import DotSVG from 'components/DotSVG';
import { mediaBreakpointDown } from 'utils/styledCssHelpers';

export const SSection = styled.section`
  background-color: ${props => props.theme.colors[props.color]};
  padding: 100px 0;
  position: relative;
  ${mediaBreakpointDown(
    'sm',
    `
  padding: 50px 0;

  `,
  )}
`;

export const SContainer = styled(Container)``;

export const SSectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  color: ${props => {
    switch (props.color) {
      case 'white':
      case 'light_grey':
        return props.theme.colors.main;
      default:
        return props.theme.colors.white;
    }
  }};
`;

export const SFaq = styled.div`
  height: 100%;
  overflow: hidden;
`;

export const SFaqTitle = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 120px;
  &:hover {
    cursor: pointer;
  }
  border-radius: 3px;
  span {
    display: block;
    color: inherit;
  }
  span.title {
    width: 80%;
  }
  span.svg-container {
    margin-left: 10px;
    width: 30px;
    height: 30px;
    flex: 1 1 30px;
    text-align: right;
  }
  svg {
    fill: ${props => {
      switch (props.color) {
        case 'white':
        case 'light_grey':
          return props.theme.colors.main;
        default:
          return props.theme.colors.white;
      }
    }};
  }
  border: 1px solid
    ${props => {
      switch (props.color) {
        case 'white':
        case 'light_grey':
          return props.theme.colors.main;
        default:
          return props.theme.colors.white;
      }
    }};
  &.active,
  &:hover {
    background: ${props => {
      switch (props.color) {
        case 'white':
        case 'light_grey':
          return props.theme.colors.main;
        default:
          return props.theme.colors.white;
      }
    }};
    color: ${props => props.theme.colors.pastel_blue};
    svg {
      fill: ${props => props.theme.colors.accent};
    }
  }
  &.active {
    border-radius: 3px 3px 0px 0px;
    height: auto;
  }
  &.inactive {
    // height: auto;
  }
`;

export const SFaqTitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 15px 30px;
`;

export const SFaqBody = styled.div`
  padding: 15px 30px;
  &.active {
    background: ${props => {
      switch (props.color) {
        case 'white':
        case 'light_grey':
          return props.theme.colors.main;
        default:
          return props.theme.colors.white;
      }
    }};
    color: #fff;
    border-radius: 0px 0px 3px 3px;
  }
  a {
    color: ${props => props.theme.colors.accent};
  }
`;

export const SDotSVG = styled(DotSVG)`
  overflow: hidden;
`;
